!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("classnames"), require("react")) : "function" == typeof define && define.amd ? define("ReactSideNav", ["classnames", "react"], t) : "object" == typeof exports ? exports.ReactSideNav = t(require("classnames"), require("react")) : e.ReactSideNav = t(e.classNames, e.React);
}(window, function (e, t) {
  return function (e) {
    var t = {};

    function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = e, n.c = t, n.d = function (e, t, r) {
      n.o(e, t) || Object.defineProperty(e, t, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, n.r = function (e) {
      Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return n.d(t, "a", t), t;
    }, n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 18);
  }([function (t, n) {
    t.exports = e;
  }, function (e, t, n) {
    e.exports = n(16)();
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = s(n(2)),
        i = s(n(1)),
        a = s(n(0));

    function s(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var u = function e(t) {
      return t.link ? o.default.createElement("div", {
        className: (0, a.default)("side-nav-item", "level-" + t.level, {
          active: t.active
        })
      }, t.linkComponent ? o.default.createElement(t.linkComponent, {
        to: t.link,
        label: t.label,
        icon: t.icon ? t.icon + " side-nav-icon" : null,
        className: "side-nav-item-link"
      }) : null) : o.default.createElement("div", {
        className: (0, a.default)("side-nav-item", "level-" + t.level, {
          collapsed: !t.expanded,
          expanded: t.expanded,
          active: t.active
        }),
        onClick: t.onItemClick(t.id)
      }, o.default.createElement("div", {
        className: (0, a.default)("side-nav-item-title", {
          animateIn: t.animationState >= 1
        }, {
          animateOut: 2 === t.animationState
        })
      }, t.iconComponent && t.icon ? o.default.createElement(t.iconComponent, {
        className: (0, a.default)("side-nav-icon", t.icon)
      }) : null, t.label, t.chevronComponent ? o.default.createElement(t.chevronComponent, {
        expanded: t.expanded || t.active,
        className: "side-nav-chevron"
      }) : null), o.default.createElement("div", {
        className: "side-nav-item-children"
      }, t.items && Array.isArray(t.items) ? t.items.map(function (n) {
        return o.default.createElement(e, r({
          key: n.id,
          level: t.level + 1,
          linkComponent: t.linkComponent,
          chevronComponent: t.chevronComponent,
          iconComponent: t.iconComponent,
          onItemClick: t.onItemClick
        }, n));
      }) : null));
    };

    u.propTypes = {
      label: i.default.string.isRequired,
      id: i.default.oneOfType([i.default.string, i.default.number]).isRequired,
      onItemClick: i.default.func.isRequired,
      level: i.default.number.isRequired,
      linkComponent: i.default.func,
      link: i.default.string,
      icon: i.default.string,
      active: i.default.bool,
      expanded: i.default.bool,
      items: i.default.arrayOf(i.default.object),
      chevronComponent: i.default.func,
      iconComponent: i.default.func,
      animationState: i.default.number
    }, u.defaultProps = {
      link: null,
      icon: null,
      active: !1,
      expanded: !1,
      items: null,
      chevronComponent: null,
      iconComponent: null,
      linkComponent: null,
      animationState: 0
    }, t.default = u;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.Icon = t.Chevron = void 0;
    var r = a(n(2)),
        o = a(n(1)),
        i = a(n(0));

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var s = t.Chevron = function (e) {
      return r.default.createElement("i", {
        className: (0, i.default)("fas", e.className, {
          "fa-chevron-left": !e.expanded,
          "fa-chevron-down": e.expanded
        })
      });
    };

    s.propTypes = {
      className: o.default.string,
      expanded: o.default.bool
    }, s.defaultProps = {
      className: "",
      expanded: !1
    };

    var u = t.Icon = function (e) {
      return r.default.createElement("i", {
        className: (0, i.default)(e.className)
      });
    };

    u.propTypes = {
      className: o.default.string
    }, u.defaultProps = {
      className: ""
    };
  },, function (e, t, n) {}, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" != typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" != typeof e) return e;
      var n = t.protocol + "//" + t.host,
          r = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var o,
            i = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
      });
    };
  }, function (e, t, n) {
    var r,
        o,
        i = {},
        a = (r = function r() {
      return window && document && document.all && !window.atob;
    }, function () {
      return void 0 === o && (o = r.apply(this, arguments)), o;
    }),
        s = function (e) {
      var t = {};
      return function (e) {
        if ("function" == typeof e) return e();

        if (void 0 === t[e]) {
          var n = function (e) {
            return document.querySelector(e);
          }.call(this, e);

          if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
            n = n.contentDocument.head;
          } catch (e) {
            n = null;
          }
          t[e] = n;
        }

        return t[e];
      };
    }(),
        u = null,
        c = 0,
        l = [],
        f = n(7);

    function p(e, t) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
            o = i[r.id];

        if (o) {
          o.refs++;

          for (var a = 0; a < o.parts.length; a++) {
            o.parts[a](r.parts[a]);
          }

          for (; a < r.parts.length; a++) {
            o.parts.push(y(r.parts[a], t));
          }
        } else {
          var s = [];

          for (a = 0; a < r.parts.length; a++) {
            s.push(y(r.parts[a], t));
          }

          i[r.id] = {
            id: r.id,
            refs: 1,
            parts: s
          };
        }
      }
    }

    function d(e, t) {
      for (var n = [], r = {}, o = 0; o < e.length; o++) {
        var i = e[o],
            a = t.base ? i[0] + t.base : i[0],
            s = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function m(e, t) {
      var n = s(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = l[l.length - 1];
      if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), l.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = s(e.insertInto + " " + e.insertAt.before);
        n.insertBefore(t, o);
      }
    }

    function v(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = l.indexOf(e);
      t >= 0 && l.splice(t, 1);
    }

    function h(e) {
      var t = document.createElement("style");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), b(t, e.attrs), m(e, t), t;
    }

    function b(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function y(e, t) {
      var n, r, o, i;

      if (t.transform && e.css) {
        if (!(i = t.transform(e.css))) return function () {};
        e.css = i;
      }

      if (t.singleton) {
        var a = c++;
        n = u || (u = h(t)), r = I.bind(null, n, a, !1), o = I.bind(null, n, a, !0);
      } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", b(t, e.attrs), m(e, t), t;
      }(t), r = function (e, t, n) {
        var r = n.css,
            o = n.sourceMap,
            i = void 0 === t.convertToAbsoluteUrls && o;
        (t.convertToAbsoluteUrls || i) && (r = f(r));
        o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
        var a = new Blob([r], {
          type: "text/css"
        }),
            s = e.href;
        e.href = URL.createObjectURL(a), s && URL.revokeObjectURL(s);
      }.bind(null, n, t), o = function o() {
        v(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = h(t), r = function (e, t) {
        var n = t.css,
            r = t.media;
        r && e.setAttribute("media", r);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), o = function o() {
        v(n);
      });

      return r(e), function (t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          r(e = t);
        } else o();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = a()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = d(e, t);
      return p(n, t), function (e) {
        for (var r = [], o = 0; o < n.length; o++) {
          var a = n[o];
          (s = i[a.id]).refs--, r.push(s);
        }

        e && p(d(e, t), t);

        for (o = 0; o < r.length; o++) {
          var s;

          if (0 === (s = r[o]).refs) {
            for (var u = 0; u < s.parts.length; u++) {
              s.parts[u]();
            }

            delete i[s.id];
          }
        }
      };
    };

    var g,
        x = (g = [], function (e, t) {
      return g[e] = t, g.filter(Boolean).join("\n");
    });

    function I(e, t, n, r) {
      var o = n ? "" : r.css;
      if (e.styleSheet) e.styleSheet.cssText = x(t, o);else {
        var i = document.createTextNode(o),
            a = e.childNodes;
        a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      return t.toString = function () {
        return this.map(function (t) {
          var n = function (e, t) {
            var n = e[1] || "",
                r = e[3];
            if (!r) return n;

            if (t && "function" == typeof btoa) {
              var o = (a = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
                  i = r.sources.map(function (e) {
                return "/*# sourceURL=" + r.sourceRoot + e + " */";
              });
              return [n].concat(i).concat([o]).join("\n");
            }

            var a;
            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" == typeof e && (e = [[null, e, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" == typeof i && (r[i] = !0);
        }

        for (o = 0; o < e.length; o++) {
          var a = e[o];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
        }
      }, t;
    };
  }, function (e, t, n) {
    (e.exports = n(9)(!1)).push([e.i, ".side-nav .side-nav-item{cursor:pointer}.side-nav .side-nav-item .side-nav-item-children{max-height:9999px;overflow:hidden;transition:max-height 1s ease-in-out}.side-nav .side-nav-item.collapsed .side-nav-item-children{max-height:0;transition:max-height .3s cubic-bezier(0,1,0,1) -.15s}.side-nav .side-nav-item.active .side-nav-item-children{max-height:9999px;transition:none}", ""]);
  }, function (e, t, n) {
    var r = n(10);
    "string" == typeof r && (r = [[e.i, r, ""]]);
    var o = {
      hmr: !1,
      transform: void 0,
      insertInto: void 0
    };
    n(8)(r, o);
    r.locals && (e.exports = r.locals);
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = (t.createItemTree = function e(t) {
      var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
      return t.map(function (t) {
        return t.items ? r({
          expanded: !1,
          active: !1,
          level: n,
          animationState: 0
        }, t, {
          items: e(t.items, n + 1)
        }) : r({
          expanded: !1,
          active: !1,
          level: n,
          animationState: 0
        }, t);
      });
    }, t.collapseTree = function e(t) {
      return t.map(function (t) {
        return t.items ? r({}, t, {
          expanded: !1,
          items: e(t.items)
        }) : r({}, t, {
          expanded: !1
        });
      });
    }),
        i = t.deactivateTree = function e(t) {
      return t.map(function (t) {
        return t.items ? r({}, t, {
          active: !1,
          items: e(t.items)
        }) : r({}, t, {
          active: !1
        });
      });
    },
        a = function e(t, n, a) {
      var s = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null,
          u = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
      return n.map(function (n) {
        var c,
            l = r({}, n);
        return a && l.id === a || !a && l.link && l.link === s ? (t || (l.expanded = !l.expanded), t && (l.active = !0), !t && l.items && (l.items = o(l.items)), t && l.items && (l.items = i(l.items)), u && u()) : (t || (l.expanded = !1), t && (l.active = !1), l.items && (l.items = t ? e(!0, l.items, a, s, (c = l, function () {
          c.active = !0;
        })) : e(!1, l.items, a, s, function (e) {
          return function () {
            e.expanded = !0;
          };
        }(l))), !t && l.expanded && u && u(), t && l.active && u && u()), l;
      });
    };

    t.toggleExpandedItemWithId = function (e, t) {
      return a(!1, t, e);
    }, t.toggleExpandedItemWithLink = function (e, t) {
      return a(!1, t, null, e);
    }, t.activateItemWithId = function (e, t) {
      return a(!0, t, e);
    }, t.activateItemWithLink = function (e, t) {
      return a(!0, t, null, e);
    }, t.animateItemWithId = function (e, t, n) {
      return t.map(function (t) {
        if (t.id === e && void 0 !== t.animationTime) {
          var o = r({}, t);
          return o.animationState = 2 === o.animationState ? 0 : o.animationState + 1, o.animationState && setTimeout(function () {
            return n(e);
          }, t.animationTime), o;
        }

        return t;
      });
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    var r = function r(e) {};

    e.exports = function (e, t, n, o, i, a, s, u) {
      if (r(t), !e) {
        var c;
        if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var l = [n, o, i, a, s, u],
              f = 0;
          (c = new Error(t.replace(/%s/g, function () {
            return l[f++];
          }))).name = "Invariant Violation";
        }
        throw c.framesToPop = 1, c;
      }
    };
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return function () {
        return e;
      };
    }

    var o = function o() {};

    o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
      return this;
    }, o.thatReturnsArgument = function (e) {
      return e;
    }, e.exports = o;
  }, function (e, t, n) {
    "use strict";

    var r = n(15),
        o = n(14),
        i = n(13);

    e.exports = function () {
      function e(e, t, n, r, a, s) {
        s !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = r, n.PropTypes = n, n;
    };
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
        }
      }

      return function (t, n, r) {
        return n && e(t.prototype, n), r && e(t, r), t;
      };
    }(),
        i = n(2),
        a = f(i),
        s = f(n(1)),
        u = f(n(0)),
        c = f(n(3)),
        l = n(12);

    function f(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function p(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    n(11), n(6);

    var d = function (e) {
      function t() {
        var e, n, o;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, t);

        for (var i = arguments.length, s = Array(i), f = 0; f < i; f++) {
          s[f] = arguments[f];
        }

        return n = o = p(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [this].concat(s))), o.state = {
          items: [],
          activeItemLink: null
        }, o.onItemClick = function (e) {
          return function (t) {
            t.stopPropagation(), t.nativeEvent.stopImmediatePropagation(), t.preventDefault();
            var n = o.toggleItem(e);
            o.animateItem(e, n);
          };
        }, o.animateItem = function (e, t) {
          var n = (0, l.animateItemWithId)(e, void 0 !== t ? t : o.state.items, o.animateItem);
          o.setState({
            items: n
          });
        }, o.toggleItem = function (e) {
          return (0, l.toggleExpandedItemWithId)(e, o.state.items);
        }, o.renderItems = function () {
          return o.state.items.map(function (e) {
            return a.default.createElement(c.default, r({
              key: e.id,
              level: 0,
              linkComponent: o.props.linkComponent,
              chevronComponent: o.props.chevronComponent,
              iconComponent: o.props.iconComponent,
              onItemClick: o.onItemClick
            }, e));
          });
        }, o.render = function () {
          return a.default.createElement("div", {
            className: (0, u.default)("side-nav", o.props.className, {
              "default-theme": !o.props.className
            })
          }, o.renderItems());
        }, p(o, n);
      }

      return function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
      }(t, i.Component), o(t, [{
        key: "componentWillMount",
        value: function value() {
          var e = this.props.items ? (0, l.createItemTree)(this.props.items) : [];
          this.props.activeItem && this.props.items && (e = (0, l.activateItemWithLink)(this.props.activeItem, e)), this.setState({
            activeItemLink: this.props.activeItem,
            items: e
          });
        }
      }, {
        key: "componentWillReceiveProps",
        value: function value(e) {
          if (e && e.activeItem) {
            var t = (0, l.activateItemWithLink)(e.activeItem, this.state.items);
            this.setState({
              activeItemLink: e.activeItem,
              items: t
            });
          }
        }
      }]), t;
    }();

    d.propTypes = {
      linkComponent: s.default.func,
      items: s.default.arrayOf(s.default.object),
      activeItem: s.default.string,
      className: s.default.string,
      chevronComponent: s.default.func,
      iconComponent: s.default.func
    }, d.defaultProps = {
      items: null,
      activeItem: null,
      className: null,
      chevronComponent: null,
      iconComponent: null,
      linkComponent: null
    }, t.default = d;
  }, function (e, t, n) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var r = n(17);
    Object.defineProperty(t, "SideNav", {
      enumerable: !0,
      get: function get() {
        return a(r).default;
      }
    });
    var o = n(3);
    Object.defineProperty(t, "SideNavItem", {
      enumerable: !0,
      get: function get() {
        return a(o).default;
      }
    });
    var i = n(4);

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "Chevron", {
      enumerable: !0,
      get: function get() {
        return i.Chevron;
      }
    }), Object.defineProperty(t, "Icon", {
      enumerable: !0,
      get: function get() {
        return i.Icon;
      }
    });
  }]);
});